import lottie from "lottie-web";

export const LogoMask = {
  init: () => {
    LogoMask.setLottie();
  },
  setLottie: () => {
    LogoMask.logo = lottie.loadAnimation({
      container: document.getElementById("logo-svgMask"),
      renderer: "svg",
      loop: false,
      autoplay: false,
      // path: "../data/opening.json",
      path:"/wp-content/themes/snows/data/opening.json"
    });
    // LogoMask.logo.addEventListener('DOMLoaded', e=> {});
  },
  play:()=>{
    setTimeout(()=>{
      LogoMask.logo.play();
    },500)
  },

  // playSegments:()=>{
  //   LogoMask.logo.playSegments([70,80], true);
  // },
  // reStart:()=>{
  //   LogoMask.logo.playSegments([80,120], true);
  // },
  // goToAndStop:(f)=>{
  //   LogoMask.logo.goToAndStop(30, true)
  // },
  // lottiePlay: () => {
  //   if (!Global.isLogoAnima) {
  //     Global.isLogoAnima = true;
  //     LogoMask.logo.setDirection(0);
  //   }
  // },
};
